import { Component } from '@angular/core';

@Component({
  selector: 'app-power-app',
  standalone: true,
  imports: [],
  templateUrl: './power-app.component.html',
  styleUrl: './power-app.component.css'
})
export class PowerAppComponent {

}
